export enum ProductType {
  NgsoTubes = 'ngsotubes',
  NgsoPlates = 'ngsoplates',
  NGSO_Plate_8ch = 'NGSO_Plate_8ch',
  NGSO_Plate_12ch = 'NGSO_Plate_12ch',
  NGSO_Plate_8ch_mixed = 'NGSO_Plate_8ch_mixed',
  NGSO_Plate_12ch_mixed = 'NGSO_Plate_12ch_mixed',
}
export enum ActiveLinkType {
  EntryMethod = 'entryMethod',
  ConfirmOrder = 'confirmOrder',
}
export enum Products {
  Ngso = 'ngso',
}
export enum UploadType {
  copyPaste = 'copyPaste',
  fileUpload = 'fileUpload',
}
export enum AdditionalServicesOptions {
  Annealing = 'AS1',
  AnnealingAndPooling = 'AS2',
  AnnealingQC = 'AS3',
  COA = 'AS6',
  HPLC = 'AS5',
}
export enum NGSOTypeOptions {
  NGSOBronze = 'NGSO1',
  NGSOSilver = 'NGSO2',
  NGSOGold = 'NGSO4',
}
export enum NgsoType {
  NGSO1 = 'NGSO-Bronze',
  NGSO2 = 'NGSO-Silver',
  NGSO4 = 'NGSO-Gold',
}
export enum ShippingMessageKey {
  Ambient = 'CONF_AMBIENT_ROOM_TEMP',
  Frozen = 'FROZEN',
}

export enum FileFormat {
  InvalidTemplate = 'INVALID_TEMPLATE',
  MultipleLineError = 'MULTIPLE_LINE_ERROR',
  AcceptFormat = '.csv,.xls,.xlsx, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
  ValidateInput = 'VALIDATE_INPUT',
}

export enum StartRow {
  ngsotubes = 13,
  ngsoplates = 12,
}

export enum ProductUploadType {
  Name = 'Oligo Name',
  Mod_5 = "5' Mod",
  Sequence = 'Sequence',
  Mod_3 = "3' Mod",
  Scale = 'Scale (µmole)',
  Format = 'Format',
  Comments = 'Notes (Optional)',
  Row = 'Row',
  Column = 'Column',
  PlatesSequence = "Sequence (5' - 3')",
  PlatesComments = 'Comments',
  platesSpecification = 'Specifications & Minimum Yields',
  Trademark = 'Trademarks',
}
export enum Modifications {
  None = '[None]',
  priceQuote = 'QUOTE',
  NaN = 'NaN',
  Dry = 'DRY',
  Scale = '1.0000',
}

export enum NGSOProperties {
  NameMaxLength = 30,
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
  Success = 'success',
}
